/**
 * Green Flag — CheckInCodeLarge
 *
 * The attendee's check-in code shown inline on the event page, big enough to
 * scan, for the last few hours before the event. Tapping it opens the
 * check-in sheet, which refetches the registration so a code a host has just
 * scanned shows as checked in.
 */

import { Box, Flex, Image, Text, chakra } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { checkInQrSrc } from "../../lib/checkInQrSrc";

export interface CheckInCodeLargeProps {
  token: string;
  checkedIn: boolean;
  onShow: () => void;
}

export function CheckInCodeLarge({
  token,
  checkedIn,
  onShow,
}: CheckInCodeLargeProps) {
  return (
    <chakra.button
      type="button"
      onClick={onShow}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="0.75rem"
      w="100%"
      mt="0.875rem"
      p="1rem"
      borderRadius="md"
      bg="greenLight.subtle"
      border="none"
      color="fg.default"
      cursor="pointer"
      textAlign="center"
      _hover={{ bg: "bg.brandSoft" }}
    >
      {checkedIn ? (
        <Flex direction="column" align="center" gap="0.5rem" py="0.5rem">
          <Flex
            align="center"
            justify="center"
            boxSize="3.5rem"
            borderRadius="full"
            bg="bg.brandSoft"
            color="fg.onTint"
            fontSize="1.5rem"
          >
            <FontAwesomeIcon icon={faCheck} />
          </Flex>
          <Text textStyle="sectionHeading">You're checked in!</Text>
        </Flex>
      ) : (
        <>
          <Box>
            <Text textStyle="sectionHeading">Your check-in code</Text>
            <Text textStyle="finePrint" color="fg.muted" mt="0.125rem">
              Show this at the door — we'll scan it and you're in.
            </Text>
          </Box>
          <Box p="0.625rem" bg="bg.canvas" borderRadius="sm">
            <Image
              src={checkInQrSrc(token)}
              alt="Your check-in QR code"
              boxSize="168px"
            />
          </Box>
        </>
      )}
    </chakra.button>
  );
}
